import React, { lazy } from 'react'
import { Route } from 'react-router'
import { SubRouter } from '@/router/SubRouter'

const Index = lazy(() => import('./Index'))

export const AnalyticsMemberRouter = React.memo(() => (
  <SubRouter loggedIn roles={['role--analytics--crew']}>
    <Route index element={<Index />} />
  </SubRouter>
))
